import React from "react";
import { Table, Typography, Space, Button, Popconfirm, Tag, Card } from "antd";
import dayjs from "dayjs";
import { formatCurrency } from "../utils";

const { Text } = Typography;

export default function RazaoTable({
    loading,
    lancamentosFiltrados,
    selectedLancamentos,
    setSelectedLancamentos,
    setEditingId,
    setEditVisible,
    handleDeletar
}) {
    const columnsPrincipal = [
        {
            title: "Conta",
            dataIndex: "codigo",
            width: 140,
            render: (t) => <span className="code-pill">{t}</span>
        },
        {
            title: "Nome / Descrição",
            dataIndex: "nome",
            render: (t) => <Text strong style={{ color: '#0f172a', fontSize: '15px' }}>{t}</Text>
        },
        {
            title: "Saldo Inicial",
            dataIndex: "saldoAnterior",
            align: 'right',
            width: 150,
            render: (v) => <Text style={{ color: '#64748b', fontWeight: 500 }}>{formatCurrency(v)}</Text>
        },
        {
            title: "Débitos (+)",
            dataIndex: "debitos",
            align: 'right',
            width: 130,
            render: (v) => v > 0 ? <Text style={{ color: '#10b981', fontWeight: 600 }}>{formatCurrency(v)}</Text> : "-"
        },
        {
            title: "Créditos (-)",
            dataIndex: "creditos",
            align: 'right',
            width: 130,
            render: (v) => v > 0 ? <Text style={{ color: '#ef4444', fontWeight: 600 }}>{formatCurrency(v)}</Text> : "-"
        },
        {
            title: "Saldo Final",
            dataIndex: "saldoFinal",
            align: 'right',
            width: 160,
            render: (v) => (
                <div style={{ background: v < 0 ? '#fef2f2' : '#f0fdf4', padding: '4px 12px', borderRadius: '8px', display: 'inline-block' }}>
                    <Text strong style={{ color: v < 0 ? '#ef4444' : '#10b981', fontSize: '15px' }}>
                        {formatCurrency(v)}
                    </Text>
                </div>
            )
        },
    ];

    const expandedRowRender = (record) => {
        const dataSourceExtrato = [
            { id: 'header-' + record.codigo, isHeader: true, nome: 'SALDO INICIAL DO PERÍODO', saldoAcumulado: record.saldoAnterior },
            ...record.lancamentos
        ];

        return (
            <div className="expanded-table-wrapper animate-fade-in">
                <Table
                    dataSource={dataSourceExtrato}
                    rowKey="id"
                    pagination={false}
                    size="middle"
                    className="inner-razao-table"
                    rowSelection={{
                        selectedRowKeys: selectedLancamentos.map(l => l.id),
                        onChange: (_, rows) => {
                            // Filtra apenas os que não são header
                            setSelectedLancamentos(rows.filter(r => !r.isHeader));
                        },
                        getCheckboxProps: (record) => ({
                            disabled: record.isHeader,
                            style: { visibility: record.isHeader ? 'hidden' : 'visible' }
                        }),
                    }}
                    columns={[
                        {
                            title: "Data",
                            dataIndex: "dataReferencia",
                            width: 110,
                            render: (d, row) => row.isHeader ? "" : <Text type="secondary" style={{ fontSize: '13px' }}>{dayjs(d).format("DD/MM/YYYY")}</Text>
                        },
                        {
                            title: "Histórico",
                            dataIndex: "nome",
                            render: (t, row) => row.isHeader ? <Text strong style={{ color: '#1890ff' }}>{t}</Text> : <Text style={{ color: '#334155' }}>{t}</Text>
                        },
                        {
                            title: "Contrapartida",
                            dataIndex: "contrapartida",
                            render: (t, row) => row.isHeader ? "" : <Text type="secondary" italic style={{ fontSize: '12px' }}>{t}</Text>
                        },
                        {
                            title: "Débito (+)",
                            dataIndex: "valorDebito",
                            align: 'right',
                            width: 120,
                            render: (v, row) => row.isHeader ? "" : (v > 0 ? <Text style={{ color: '#10b981', fontWeight: 500 }}>{formatCurrency(v)}</Text> : "-")
                        },
                        {
                            title: "Crédito (-)",
                            dataIndex: "valorCredito",
                            align: 'right',
                            width: 120,
                            render: (v, row) => row.isHeader ? "" : (v > 0 ? <Text style={{ color: '#ef4444', fontWeight: 500 }}>{formatCurrency(v)}</Text> : "-")
                        },
                        {
                            title: "Saldos",
                            dataIndex: "saldoAcumulado",
                            align: 'right',
                            width: 140,
                            render: (v) => <Text strong style={{ color: v < 0 ? '#ef4444' : '#0f172a' }}>{formatCurrency(v)}</Text>
                        },
                        {
                            title: "Ações",
                            width: 130,
                            align: 'center',
                            render: (_, r) => r.isHeader ? null : (
                                <Space size="small">
                                    <Button
                                        type="text"
                                        size="small"
                                        className="btn-edit-action"
                                        style={{ color: '#1890ff', fontWeight: 600 }}
                                        onClick={() => { setEditingId(r.id); setEditVisible(true); }}
                                    >
                                        Editar
                                    </Button>
                                    <Popconfirm
                                        title="Remover lançamento?"
                                        onConfirm={() => handleDeletar(r.id)}
                                        okText="Excluir"
                                        cancelText="Cancelar"
                                    >
                                        <Button type="text" size="small" danger style={{ fontWeight: 600 }}>
                                            Excluir
                                        </Button>
                                    </Popconfirm>
                                </Space>
                            )
                        }
                    ]}
                />
            </div>
        );
    };

    return (
        <Card className="premium-card table-card animate-fade-in" bodyStyle={{ padding: 0 }} bordered={false} style={{ animationDelay: '0.2s' }}>
            <Table
                dataSource={lancamentosFiltrados}
                columns={columnsPrincipal}
                rowKey="codigo"
                size="large"
                loading={loading}
                pagination={false}
                expandable={{
                    defaultExpandAllRows: true,
                    expandedRowRender,
                    rowExpandable: () => true
                }}
                rowClassName="razao-parent-row"
            />
        </Card>
    );
}
